export const assignments = state => state.orderAssignments

export const assignmentsPagination = state => state.pagination

export const assignmentsFilters = state => state.filters

export const assignmentUpdatesCount = state => state.updatesCount

export const currentAssignmentsStatus = state => state.status
